<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? '新增' : dataForm.gameRankDTO.status === 4 ? '修改':'活动细则'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close='closeHandle'
  >
    <el-form
      :disabled="dataForm.gameRankDTO.status === 4 ? false : dataForm.id ? true : false"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"
    >
      <el-form-item label="活动名称" prop="gameRankDTO.name">
        <el-input v-model="dataForm.gameRankDTO.name" placeholder="活动名称"></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="gameRankDTO.startTime">
        <el-date-picker
          v-model="dataForm.gameRankDTO.startTime"
          type="datetime"
          :disabled="timeLimited"
          value-format="timestamp"
          placeholder="年/月/日"
        ></el-date-picker>&nbsp;至&nbsp;
        <el-date-picker
          prop="gameRankDTO.endTime"
          v-model="dataForm.gameRankDTO.endTime"
          type="datetime"
          value-format="timestamp"
          placeholder="年/月/日"
          @change="changeEndTime(dataForm.gameRankDTO.endTime)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动规则" prop="describe">
        <quill quillId="describe" ref="quills"></quill>
      </el-form-item>

      <el-form-item
        prop="gameRankDTO.partake"
        label="参与用户"
        :disabled="dataForm.gameRankDTO.id?true:false"
      >
        <el-checkbox-group v-model="dataForm.gameRankDTO.partake">
          <el-checkbox label="mMIN">迷你</el-checkbox>
          <el-checkbox label="mSTD">标准</el-checkbox>
          <el-checkbox label="mVIP">金钻</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div style="display: flex">
        <el-form-item label="游戏上限" >
          <el-select v-model="dataForm.gameRankDTO.gameRankStatus" placeholder="请选择">
            <el-option
                    v-for="item in gameRankStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
          最多可获得
        </el-form-item>

        <el-form-item prop="gameRankSum" style="margin-left: -80px;">

          <el-input style="width:100px" v-model="dataForm.gameRankDTO.gameRankSum"  @keydown="handleInput2"></el-input>次游戏机会
        </el-form-item>
      </div>

      <div style="color:#0096dc;margin-bottom:10px;cursor:pointer;float: left;
    width: 80px;" @click="addContion()">
        +添加条件组
      </div>
      <el-form-item label="参与条件">

        <condition-list
          v-for="(item,index) in dataForm.gameRankConditions"
          :key="index"
          :listLiData="item"
          @deletelist="deletelist"
        ></condition-list>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button v-if="dataForm.gameRankDTO.status === 4 || !dataForm.id" @click="closeHandle()">取消</el-button>
      <el-button v-else @click="closeHandle()">关闭</el-button>
      <el-button v-if="dataForm.gameRankDTO.status === 4 || !dataForm.id" type="primary" @click="dataFormSubmitHandle()">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import quill from "./import/table/quill.vue";
import conditionList from "./components/conditionList";
import Url from '@/views/crs/util/url';
export default {
  components: {
    quill,
    conditionList
  },
  props: ["productList"],
  data() {
    return {
      index0: -100,
      index1: -100,
      visible: false,
      timeLimited: false,
      OldEndTime: "",
      addNum: 0,
      gameRankStatusOptions: [
        {
          value: 1,
          label: "活动期"
        },
        /*{
          value: 2,
          label: "每日"
        }*/
      ],
      tradePlatformOptions: [
        {
          value: "GTS2",
          label: "PTS"
        },
        {
          value: "MT4",
          label: "MT4"
        }
      ],
      dataForm: {
        id: "",
        gameRankDTO: {
          id: "",
          name: "",
          nameEn:"",
          nameVn:"",
          startTime: "",
          endTime: "",
          describe: "",
          describeEn: "",
          describeVn: "",
          partake: [],
          status: "",
          gameRankStatus:1,
          gameRankSum:0,
          type:1,
          creator: "",
          createDate: "",
          updater: "",
          updateDate: "",
          tradePlatform:""
        },
        gameRankConditions: [
          {
            gameRankId: "",
            groupId: "",
            startTime: "",
            endTime: "",
            count: "",
            repeat: 0,
            gameRankConditionEntities: [
              {
                type: "3",
                typeOption: [
                  // {
                  //   value: "1",
                  //   label: "开户成功"
                  // },
                  {
                    value: "2",
                    label: "登录成功"
                  },
                  {
                    value: "3",
                    label: "净入金"
                  },
                  {
                    value: "4",
                    label: "交易手数"
                  },
                  {
                    value: "5",
                    label: "交易产品"
                  },
                  {
                    value: "6",
                    label: "平仓总盈亏"
                  },
                  /*{
                    value: "7",
                    label: "账户总净值"
                  }*/
                ],
                typeValue: "1",
                conditionsProductType:[],
                productList: [],
                conditionsValue: [],
                typeValueOption: [
                  {
                    value: "1",
                    label: "为真"
                  },
                  {
                    value: "2",
                    label: "为假"
                  }
                ]
              }
            ]
          }
        ],
        gameRankPrizes: [
          {
            id: "",
            index: "",
            gameRankId: "",
            name: "",
            bonus: "",
            number: "",
            probabilityMin: "",
            probabilityStd: "",
            probabilityVip: "",
            dayUpperLimit: "",
            sumUpperLimit: ""
          }
        ],
        gameRankSpecials: [
          {
            id: "",
            gameRankId: "",
            phone: "",
            name: "",
            bonus: ""
          }
        ],
        isBy: ""
      }
    };
  },
  computed: {
    dataRule() {
      return {
        "gameRankDTO.name": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "gameRankDTO.nameEn": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "gameRankDTO.nameVn": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "gameRankDTO.startTime": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "gameRankDTO.endTime": [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "gameRankDTO.tradePlatform": [
          {
            required: true,
            message: this.$t("validate.required"),
          }
        ],
        // "gameRankDTO.partake": [
        //   {
        //     required: true,
        //     message: this.$t("validate.required"),
        //     trigger: "blur"
        //   }
        // ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo("0");
        } else {
          this.$refs.quills.init("");
          this.$refs.quills1.init("");
          this.$refs.quills2.init("");
          this.dataForm.gameRankDTO.endTime=null;
          this.dataForm.isBy=null;
          this.timeLimited = false;
          this.dataForm.gameRankConditions = [];
          this.dataForm.gameRankPrizes = [];
          this.dataForm.gameRankSpecials = [];
          this.addLine();
          this.addLine1();
          this.addContion();
        }
      });
    },
    initCopy() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.getInfo("1");
        this.dataForm.id = null;
        this.dataForm.gameRankDTO.id = null;

      });
    },
    indexMethod(index) {
      return index;
    },
    changeEndTime(val) {
      if (this.dataForm.id) {
        if (val < this.OldEndTime) {
          this.dataForm.gameRankDTO.endTime = this.OldEndTime;
          this.$message("结束时间只能往后延期，请谨慎操作");
        }
      } else {
        return;
      }
    },handleInput2(e) {
    // 通过正则过滤小数点后两位
    e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null

  },
    // 获取信息
    getInfo(copy) {
      this.$axios
        .get(`${Url.gameRank.base}/activity/gameRank/${this.dataForm.id}`)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          };
          this.OldEndTime = res.data.gameRankDTO.endTime;
          this.dataForm.gameRankDTO.startTime = new Date(this.dataForm.gameRankDTO.startTime).getTime();
          this.dataForm.gameRankDTO.endTime = new Date(this.dataForm.gameRankDTO.endTime).getTime();
          for (let i in this.dataForm.gameRankConditions) {
            this.dataForm.gameRankConditions[i].startTime = new Date(this.dataForm.gameRankConditions[i].startTime).getTime();
            this.dataForm.gameRankConditions[i].endTime = new Date(this.dataForm.gameRankConditions[i].endTime).getTime();
            for (let j in this.dataForm.gameRankConditions[i]
              .gameRankConditionEntities) {
              if (this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].type == 5) {
                const val = this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsProductType;
                const url =
                        val != null && val != ""
                                ? "/product/" + val
                                : "/product/2,4,5,7";
                let _this = this;
                let temProduct = [];
                this.$axios.get(Url.gameRank.base + '/activity/gameRank' + url).then(res => {
                  if (res.code == 0) {
                    Object.keys(res.data).forEach(function(key) {
                      temProduct.push(
                              Object.assign(
                                      {},
                                      { value: res.data[key], label: key }
                              )
                      );
                    });
                    const allSelect = {
                      value: "全选",
                      label: "allSelect"
                    };
                    temProduct.unshift(allSelect);

                    this.$set(this.dataForm.gameRankConditions[i].gameRankConditionEntities[j], "productList", temProduct);
                  }
                });

                this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsValue
                        = this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].typeValue.split(",");
                this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsProductType
                        = this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsProductType.split(",");

              }
            }
          }
          if (res.data.isBy == 1) {
            this.timeLimited = true;
          } else {
            this.timeLimited = false;
          }
          if(copy == "1" || copy == 1){
              //复制内容，时间不禁用
              this.timeLimited = false;
              this.dataForm.isBy=null;
              this.dataForm.gameRankDTO.status=null;
              for(let i in this.dataForm.gameRankConditions){
                this.dataForm.gameRankConditions[i].id=i;
                for (let j in this.dataForm.gameRankConditions[i].gameRankConditionEntities){
                  this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].id=j;
                }
              }
              for(let i in this.dataForm.gameRankPrizes){
                this.dataForm.gameRankPrizes[i].id=i;
              }
              for(let i in this.dataForm.gameRankSpecials){
                this.dataForm.gameRankSpecials[i].id =i;
              }
              // console.log(JSON.stringify(this.dataForm))
          }
          this.$refs.quills.init(this.dataForm.gameRankDTO.describe);
          if (
            this.dataForm.gameRankDTO.partake != null &&
            this.dataForm.gameRankDTO.partake != "" &&
            this.dataForm.gameRankDTO.partake.indexOf(",") != -1
          ) {
            this.dataForm.gameRankDTO.partake = this.dataForm.gameRankDTO.partake.split(
              ","
            );
          } else {
            if( this.dataForm.gameRankDTO.partake != null && this.dataForm.gameRankDTO.partake != ""){
              let partake1=this.dataForm.gameRankDTO.partake;
              this.dataForm.gameRankDTO.partake = [];
              this.dataForm.gameRankDTO.partake.push(partake1);
            }else{
              this.dataForm.gameRankDTO.partake = [];
            }

          }
        })
        .catch(() => {});
    },

    addLine() {
      if(this.dataForm.isBy == "1" || this.dataForm.gameRankDTO.status =="2"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      this.dataForm.gameRankPrizes.push({
        //id: this.index0,
        gameRankId: "",
        name: "",
        bonus: Number(0).toFixed(3),
        number: Number(0).toFixed(3),
        probabilityMin: Number(0).toFixed(3),
        probabilityStd: Number(0).toFixed(3),
        probabilityVip: Number(0).toFixed(3),
        dayUpperLimit: Number(0).toFixed(3),
        sumUpperLimit: Number(0).toFixed(3)
      });
      this.index0++;
    },
    addLine1() {
      if(this.dataForm.isBy == "1" || this.dataForm.gameRankDTO.status =="2"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      this.dataForm.gameRankSpecials.push({
        //id: this.index1,
        gameRankId: "",
        phone: "",
        name: "",
        bonus: ""
      });
      this.index1++;
    },
    addContion() {
      if(this.dataForm.isBy == "1"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      // let length = this.dataForm.gameRankConditions.length;
      // if (length > 2) {
      //   this.$message("添加不能超过3条");
      //   return;
      // }
      this.dataForm.gameRankConditions.push({
        index: this.addNum,
        status: 1,
        statusOptions: [
          {
            value: 1,
            label: "活动期"
          },
          /*{
            value: 2,
            label: "每日"
          }*/
        ],

        gameRankConditionEntities: [
          {
            type: "3",
            typeOption: [
              // {
              //   value: "1",
              //   label: "开户成功"
              // },
              {
                value: "2",
                label: "登录成功"
              },
              {
                value: "3",
                label: "净入金"
              },
              {
                value: "4",
                label: "交易手数"
              },
              {
                value: "5",
                label: "交易产品"
              },
              {
                value: "6",
                label: "平仓总盈亏"
              }/*,
              {
                value: "7",
                label: "账户总净值"
              }*/
            ],
            typeValue: "1",
            proTypeValue: [],
            conditionsProductType:[],
            productList: [],
            conditionsValue: [],
            typeValueOption: [
              {
                value: "1",
                label: "为真"
              },
              {
                value: "2",
                label: "为假"
              }
            ]
          }
        ]
      });
      this.addNum++;
    },
    deletelist(idIndex) {
      if(this.dataForm.isBy == "1"){
        this.$message({
          message: '活动已开始，不可删除',
          type: 'warning'
        });
        return;
      }
      if(this.dataForm.gameRankConditions.length == 1){
        this.$message({
          message: '最少存在一个条件组',
          type: 'warning'
        });
        return
      }
      let arrIndex = "";
      if (idIndex.id) {
        for (let i in this.dataForm.gameRankConditions) {
          if (this.dataForm.gameRankConditions[i].id == idIndex.id) {
            arrIndex = i;
          }
        }
      } else {
        for (let i in this.dataForm.gameRankConditions) {
          if (this.dataForm.gameRankConditions[i].index == idIndex.index) {
            arrIndex = i;
          }
        }
      }
      this.dataForm.gameRankConditions.splice(arrIndex, 1);
    },
    handleDeleteClick(id) {
      if (this.dataForm.gameRankSpecials.length <= 1) {
        this.$message({
          message: '最少存在一条特殊设置',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否删除特殊设置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(id!=null && id !=='' && id != undefined){
          const url = Url.gameRank.base+"/activity/gameRank/specialDelete?id=" + id;
          this.$axios.delete(url).then(res => {
            if (res.code != 0) {
              return this.$message.error(res.msg);
            } else {
              this.$message({
                message: "删除特殊设置成功！",
                type: "success"
              });
              let arrIndex;

              if (id!=null && id != "") {
                for (let i in this.dataForm.gameRankSpecials) {
                  if (this.dataForm.gameRankSpecials[i].id == id) {
                    arrIndex = i;
                  }
                }
              } else {
                for (let i in this.dataForm.gameRankSpecials) {
                  if (this.dataForm.gameRankSpecials[i].index == index) {
                    arrIndex = i;
                  }
                }
              }
              this.dataForm.gameRankSpecials.splice(arrIndex, 1);
            }
          });
        }else{
          this.dataForm.gameRankSpecials.splice(1, 1);
          this.$message({
            message: "删除奖品设置成功！",
            type: "success"
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDeleteClick1(id) {
      if (this.dataForm.gameRankPrizes.length <= 1) {
        this.$message({
          message: '最少存在一条奖品设置',
          type: 'warning'
        });
        return;
      }
        this.$confirm('是否删除奖品设置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(id!=null && id !=='' && id != undefined){
            const url = Url.gameRank.base+"/activity/gameRank/prizeDelete?id=" + id;
            this.$axios.delete(url).then(res => {
              if (res.code != 0) {
                return this.$message.error(res.msg);
              } else {
                this.$message({
                  message: "删除奖品设置成功！",
                  type: "success"
                });
                let arrIndex;

                if (id!=null && id != "") {
                  for (let i in this.dataForm.gameRankPrizes) {
                    if (this.dataForm.gameRankPrizes[i].id == id) {
                      arrIndex = i;
                    }
                  }
                } else {
                  for (let i in this.dataForm.gameRankPrizes) {
                    if (this.dataForm.gameRankPrizes[i].index == index) {
                      arrIndex = i;
                    }
                  }
                }
                this.dataForm.gameRankPrizes.splice(arrIndex, 1);
              }
            });
          }else{
            alert(id);
            this.dataForm.gameRankPrizes.splice(id, 1);
            this.$message({
              message: "删除奖品设置成功！",
              type: "success"
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    closeHandle(){
      this.visible = false;
      location.reload();
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate(valid => {
          if (!valid) {
            return false;
          }
          if (this.dataForm.gameRankConditions.length == 0) {
            this.$message("至少添加一个条件组");
            return;
          }

          for (let i in this.dataForm.gameRankConditions) {
            for (let j in this.dataForm.gameRankConditions[i]
              .gameRankConditionEntities) {
              if (
                this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                  j
                ].type == 5
              ) {
                let arr01 = this.dataForm.gameRankConditions[i]
                  .gameRankConditionEntities[j].conditionsProductType;
                this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                  j
                ].conditionsProductType = arr01.join(",");
                let arr02 = this.dataForm.gameRankConditions[i]
                  .gameRankConditionEntities[j].conditionsValue;
                this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                  j
                ].typeValue = arr02.join(",");
              }else{
                this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsProductType = ""
              }

            }
          }
          this.dataForm.gameRankDTO.describe = this.$refs.quills.getHtml();

          if (
            this.dataForm.gameRankDTO.partake != null &&
            this.dataForm.gameRankDTO.partake != ""
          ) {
            this.dataForm.gameRankDTO.partake = this.dataForm.gameRankDTO.partake.join(",");
          } else {
            this.dataForm.gameRankDTO.partake = "";
          }
          this.dataForm.gameRankDTO.id = this.dataForm.id;

          if (
            this.dataForm.gameRankDTO.id == null ||
            this.dataForm.gameRankDTO.id == ""
          ) {
            for (let lucky in this.dataForm.gameRankConditions) {
              this.dataForm.gameRankConditions[lucky].gameRankId = null;
            }
            for (let lucky in this.dataForm.gameRankPrizes) {
              this.dataForm.gameRankPrizes[lucky].gameRankId = null;
            }
            for (let lucky in this.dataForm.gameRankSpecials) {
              this.dataForm.gameRankSpecials[lucky].gameRankId = null;
            }
          }
          for(let prize in this.dataForm.gameRankPrizes){
            this.dataForm.gameRankPrizes[prize].bonus=parseFloat(this.dataForm.gameRankPrizes[prize].bonus).toFixed(3);
            this.dataForm.gameRankPrizes[prize].probabilityMin=parseFloat(this.dataForm.gameRankPrizes[prize].probabilityMin).toFixed(3);
            this.dataForm.gameRankPrizes[prize].probabilityStd=parseFloat(this.dataForm.gameRankPrizes[prize].probabilityStd).toFixed(3);
            this.dataForm.gameRankPrizes[prize].probabilityVip=parseFloat(this.dataForm.gameRankPrizes[prize].probabilityVip).toFixed(3);
            this.dataForm.gameRankPrizes[prize].dayUpperLimit=parseFloat(this.dataForm.gameRankPrizes[prize].dayUpperLimit).toFixed(3);
            this.dataForm.gameRankPrizes[prize].sumUpperLimit=parseFloat(this.dataForm.gameRankPrizes[prize].sumUpperLimit).toFixed(3);
          }
          this.$axios({
            headers:{"isAjax": 'true', 'Content-Type': 'application/json'},
            method:!this.dataForm.gameRankDTO.id ? "post" : "put",
            url:Url.gameRank.base+"/activity/gameRank/save",
            data:this.dataForm
          }).then(res => {
              if (res.code !== 0) {
                if (this.dataForm.gameRankDTO.partake != null && this.dataForm.gameRankDTO.partake != "" ) {
                  this.dataForm.gameRankDTO.partake = this.dataForm.gameRankDTO.partake.split(",");
                } else {
                  this.dataForm.gameRankDTO.partake = [];
                }
                for (let i in this.dataForm.gameRankConditions) {
                  for (let j in this.dataForm.gameRankConditions[i]
                          .gameRankConditionEntities) {
                    if (
                            this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                                    j
                                    ].type == 5
                    ) {

                      let arr01 = this.dataForm.gameRankConditions[i]
                              .gameRankConditionEntities[j].conditionsProductType;
                      if(arr01 != null && arr01 != ""){
                        this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                                j
                                ].conditionsProductType = arr01.split(",");
                      }else{
                        this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                                j
                                ].conditionsProductType = []
                      }
                      let arr02 = this.dataForm.gameRankConditions[i]
                              .gameRankConditionEntities[j].typeValue;
                      if(arr02 !=null && arr02 != ""){
                        this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                                j
                                ].conditionsValue = arr02.split(",");
                      }else{
                        this.dataForm.gameRankConditions[i].gameRankConditionEntities[
                                j
                                ].conditionsValue = []
                      }
                    }else{
                      this.dataForm.gameRankConditions[i].gameRankConditionEntities[j].conditionsProductType = []
                    }

                  }
                }
                return this.$message.error(res.msg);
              }
              this.$message({
                message: "成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                  location.reload();
                }
              });
              this.visible = false;
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    )
  }
};
</script>
<style lang="scss" scoped>
.price_set {
  ul {
    li {
      ul {
        display: flex;
        li {
          width: 50px;
          input {
            width: 50px;
          }
        }
      }
    }
  }
}
ul,
li {
  list-style: none;
}
</style>
